/**
 * Date Range Calculation Helpers
 *
 * These helpers calculate start and end dates for different time ranges
 */

export type TimeRange = "1D" | "1W" | "1M" | "6M" | "1Y" | "CUSTOM";

export interface DateRangeResult {
  startDate: string;
  endDate: string;
}

/**
 * Calculate date range for a given time range type
 * @param timeRange - Type of time range (1D, 1W, 1M, 6M, 1Y, CUSTOM)
 * @param customDate - Optional custom date for CUSTOM range
 * @returns Object with startDate and endDate as ISO strings
 */
export const getDateRangeForTimeRange = (
  timeRange: TimeRange,
  customDate?: Date
): DateRangeResult => {
  const endDate = new Date();
  const startDate = new Date();

  switch (timeRange) {
    case "CUSTOM":
      if (customDate) {
        startDate.setTime(customDate.getTime());
        startDate.setHours(0, 0, 0, 0);
        endDate.setTime(customDate.getTime());
        endDate.setHours(23, 59, 59, 999);
      }
      break;
    case "1D":
      startDate.setHours(0, 0, 0, 0);
      break;
    case "1W":
      startDate.setDate(endDate.getDate() - 7);
      break;
    case "1M":
      startDate.setDate(endDate.getDate() - 30);
      break;
    case "6M":
      startDate.setMonth(endDate.getMonth() - 6);
      break;
    case "1Y":
      startDate.setFullYear(endDate.getFullYear() - 1);
      break;
  }

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
};
